<template>
  <!-- 审批进度 -->
  <div class="approval-content">
    <h4>
      <span class="font18">审批进度&nbsp;:&nbsp;</span>
      <span>{{ approvalData.spjd }}</span>
    </h4>
    
    <van-steps
      class="ld-step"
      direction="vertical"
      :active="approvalData.spjdInfoList.length"
    >
      <van-step>
        <div>提交申请 <span class="font12 gray">{{ approvalData.sentTime }}</span></div>
        <div
          class="mt5 font12"
          v-html="approvalData.sentEmpName"
        />
        <span class="gray">{{ approvalData.sentRemark }}</span>
      </van-step>
      <van-step
        v-for="(item, index) in approvalData.spjdInfoList"
        :class="[
          item.flowState === 0 ? 'gray' : '',
          item.flowState === 1 ? 'green' : '',
          item.flowState === 2 ? 'red' : '',
          item.flowState === 3 ? 'gray' : ''
        ]"
        :key="index"
      >
        <div>{{ item.flowState | filterApprovalStatus(item.jblx) }} {{ item.completeTime }}</div>
        <div class="font12">
          <div v-html="item.approveEmpName" />
          <div v-if="item.completeWay">
            {{ item.completeWay | filterApprovalWay }}回复
            {{ item.appRemark }}
          </div>
        </div>
      </van-step>
    </van-steps>
  </div>
</template>

<script>
import { Step, Steps } from 'vant'

export default {
  components: {
    [Step.name]: Step,
    [Steps.name]: Steps,
  },
  props: {
    transparent: Boolean,
    border: Boolean,
    white: Boolean,
    orderId:{
      type: String,
      default: ''
    },
    ordertype:{
      type: String,
      default: ''
    },
  },
  data () {
    return {
      // 审批进度数据
      approvalData: {
        spjdInfoList: []
      }
    }
  },
  created () {
    this.getApprovalProgress()
  },
  methods: {
    async getApprovalProgress() {
      try {
        const { data } = await this.$api['approval/vipOrderAppProgress']({
          'orderId': this.orderId,
          'orderType':this.orderType
        })
        if (data) {
          this.approvalData = data
          // if(data.spjdInfoList && data.spjdInfoList[0].flowState == 0){
          // 	this.$set(this,'isShowTilteLine',false)
          // }
        } else {
          this.$dialog.alert({ message: '没有审批进度数据！'})
        }
      } catch (error) {
        this.$toast(error.errMsg)
      }
    }
  },
  filters: {
    filterApprovalWay: function(val) {
      //审批状态 0.未开始1已通过 2未通过 3审批中 ,
      //完成方式 1.PC2.手机app3.邮件4.短信 ,
      if(val == 1) {
        return 'PC'
      }
      if(val == 2) {
        return '手机app'
      }
      if(val == 3) {
        return '邮件'
      }
      if(val == 4) {
        return '短信'
      }
    },
    filterApprovalStatus: function(val,jblx) {
      if(val == 0) {
        console.log(jblx);
        if(jblx==1){
          return '待确定'
        }
        return '待审批'
      }
      if(val == 1) {
        if(jblx==1){
          return '已确认'
        }
        return '审批通过'
      }
      if(val == 2) {
        return '审批拒绝'
      }
      if(val == 3) {
        if(jblx==1){
          return '确认中'
        }
        return '审批中'
      }
    },
  }

}

</script>

<style lang="less">
@import "~Assets/styles/business.less";
.approval-content{
  padding: 15px;
  
  h4 {
    margin: 0;
  }

  .van-step.gray {
    .van-step__title {
      color: @color-text-gray !important;
    }
  }
  .van-step.red {
    .van-step__title {
      color: @color-text-red !important;
    }
  }
  .van-step.green {
    .van-step__title {
      color: rgb(7, 193, 96) !important;
    }
  }
}

.userhead {
  width: 15px;
  margin-right: 5px;
  vertical-align: text-bottom;
}
</style>
